import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedDatagridModule } from 'src/app/shared/shared-datagrid/shared-datagrid.module';
import { DxButtonModule, DxDataGridModule } from "devextreme-angular";
import { AddEditWorkFlowComponent } from './add-edit-workflow.component';
import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
import { DashboardModule } from 'src/app/shared/shared-dashboard/dashboard.module';
import { DxTagBoxModule, DxScrollViewModule, DxTextBoxModule, DxPopupModule, DxSelectBoxModule, DxDateBoxModule, DxTabPanelModule, DxAccordionModule, DxButtonGroupModule, DxCheckBoxModule, DxRangeSliderModule, DxDropDownButtonModule, DxRadioGroupModule, DxFileUploaderModule, DxToolbarModule, DxSortableModule } from "devextreme-angular";
import { CardListPhasesModule } from '../card-list-phases/card-list-phases.module';
@NgModule({
  declarations: [
    AddEditWorkFlowComponent,
  ],
  imports: [
    CommonModule,
    SharedDatagridModule,
    DxButtonModule,
    MdbGlobalModule,
    DashboardModule,
    DxDataGridModule,
    DxTagBoxModule, 
    DxScrollViewModule, 
    DxTextBoxModule, 
    DxPopupModule, 
    DxSelectBoxModule, 
    DxDateBoxModule, 
    DxTabPanelModule, 
    DxAccordionModule, 
    DxButtonGroupModule,
    DxCheckBoxModule, 
    DxRangeSliderModule,
    DxDropDownButtonModule, 
    DxRadioGroupModule, 
    DxFileUploaderModule, 
    DxToolbarModule, 
    DxSortableModule,
    CardListPhasesModule,
  ],
  exports:[AddEditWorkFlowComponent]
})
export class AddEditWorkFlowModule { }
